import { NO_IMG } from "../constants";

export const CATEGORY_INIT = {
    img: NO_IMG,
    imgFile: '',
    category: '',
    subcategory: '',
    subcategories: []
};